import LayoutPadrao from '../layouts/LayoutPadrao.vue'
import PedidosView from '@/views/pedidos/MeusPedidosView.vue'
import RealizaPedidoView from '@/views/pedidos/RealizaPedidoView.vue'
import RealizaPedidoTesteView from '@/views/pedidos/RealizaPedidoTesteView.vue'
import RealizaPedidoTomTomView from '@/views/pedidos/RealizaPedidoTomTomView.vue'
import PendenteHistoricoView from '@/views/pedidos/PendenteHistoricoView.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: 'gerenciar-pedidos',
      name: 'gerenciar-pedidos',
      component: PedidosView,
      meta: {
        requiresAuth: true,
        title: 'Gerenciar Pedidos',
        nome_fisico: 'gerenciar-pedidos',
      },
    },
    {
      path: '/realizar-pedido',
      name: 'RealizarPedido',
      component: RealizaPedidoView,
      meta: {
        requiresAuth: true,
        title: 'Realizar Pedido',
        nome_fisico: 'realizar-pedido-endereco_externa_desativados',
      },
    },

    {
      path: '/realizar-pedido-teste',
      name: 'RealizarPedidoTeste',
      component: RealizaPedidoTesteView,
      meta: {
        requiresAuth: true,
        title: 'Realizar Pedido Teste',
        nome_fisico: 'realizar-pedido-teste',
      },
    },

    {
      path: '/realizar-pedido-tomtom',
      name: 'RealizarPedidoTeste',
      component: RealizaPedidoTomTomView,
      meta: {
        requiresAuth: true,
        title: 'Realizar Pedido TomTOm',
        nome_fisico: 'realizar-pedido-tomtom',
      },
    },

    {
      path: '/pendente-historico',
      name: 'PendenteHistorico',
      component: PendenteHistoricoView,
      meta: {
        requiresAuth: true,
        title: 'Pedidos Pendentes Histórico',
        nome_fisico: 'pendente-historico',
      },
    },
  ],
}
